import type { HTMLAttributes, ReactNode } from 'react';

export type StatusLabelVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface StatusLabelProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  variant?: StatusLabelVariant;
}

export function StatusLabel({ children, variant = 'info', className = '', ...props }: StatusLabelProps) {
  return (
    <span
      data-ui="status-label"
      data-variant={variant}
      className={`status-label inline-flex items-center rounded-lg border px-2 py-1 text-xs font-semibold ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default StatusLabel;
